import { TableCell, Typography } from "@mui/material";
import { Currency } from "../i18n/Currency";
import { CurrencyTextField } from "./general/CurrencyTextField";

export const EditableCurrencyTableCell = ({
  currency,
  value,
  onValueChange,
  min,
  max,
  align,
  editable,
  label,
  caption,
}: {
  currency: Currency;
  value?: number;
  onValueChange: (newValue: number) => void;
  min?: number;
  max?: number;
  align?: "inherit" | "left" | "center" | "right" | "justify";
  editable: boolean;
  label?: string | null;
  // a remark above the value, e.g. on a fixed amount it comes on top of
  caption?: string;
}) => {
  return (
    <TableCell align={align} sx={{ minWidth: 130 }}>
      {caption && (
        <Typography
          variant="caption"
          component="div"
          sx={{ color: "text.secondary" }}
        >
          {caption}
        </Typography>
      )}
      {editable ? (
        <CurrencyTextField
          value={value}
          label={label !== null ? label : undefined}
          onValueChange={onValueChange}
          currency={currency}
          min={min}
          max={max}
          size="small"
        />
      ) : (
        currency.format(value || 0)
      )}
    </TableCell>
  );
};
